import { render, staticRenderFns } from "./PostingSupplyCaseScan.vue?vue&type=template&id=204e5120&scoped=true&"
import script from "./PostingSupplyCaseScan.vue?vue&type=script&lang=js&"
export * from "./PostingSupplyCaseScan.vue?vue&type=script&lang=js&"
import style0 from "./PostingSupplyCaseScan.vue?vue&type=style&index=0&id=204e5120&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204e5120",
  null
  
)

export default component.exports